export default __webpack_public_path__ + "static/04-ec9f7103a957f09badb0be44fb05036e.jpg";